<template>
  <div class="results_wrapper">
    <h2>Results and Recommendation</h2>
    <div class="score_widget"><div :class="'score_widget_number swn_'+score.length">{{score}}%</div></div>
    <div class="result_description">
      <div class="goal_1" v-if="form_data.selected_goal==1"><p>
        Based on your inputs and the success data from our customers' journeys, we believe that, with SmartKarrot, you will be able to <b>increase the productivity of your CS team</b> by approximately <b class="score"> {{ score }}%</b>.
      </p>
      <p>
        This means the number of accounts handled per CSM would increase due to <b>increased workflow streamlining</b> and <b>automation of repetitive actions</b>. Also, <b>account intelligence triggers</b> will ensure that <b>actionable insights</b> are highlighted for CSMs to make quick decisions.
      </p>
      </div>
      <div class="goal_2" v-if="form_data.selected_goal==2"><p>
      Based on your inputs and the success data from our customers' journeys, we believe that you will be able to <b>achieve your growth goals</b> by <b>adjusting</b> your budget by approximately <b class="score">{{score}}%</b>. 
      </p>
      <p>
        This is achieved by driving efficiencies in your CS operations by a combination of <b>increased workflow streamlining</b> and <b>automation of repetitive actions</b>. Also, the predictive aspect of the SmartKarrot will ensure that <b>actionable insights for CSMs</b> are always highlighted thereby enabling efficient operations.
      </p></div>
      <div class="goal_3" v-if="form_data.selected_goal==3">
        <p v-if="score <= 33">
          Based on your inputs and the success data from our customers' journeys, we believe that there is <b>significant scope for optimization of your processes</b> towards driving your  <b class="score">{{score}}%</b> NRR Growth
          </p>
        <p v-if="score <= 33">This can be achieved by <b>better managing churn, improving customer experience</b>, and <b>demonstrating recurring value realization</b> with SmartKarrot. Our customers have achieved an <b>average NRR Growth of 29%</b>.
          
          </p>

        <p v-if="score > 33">
          Based on your inputs and the success data from our customers' journeys, we believe that there is <b>scope for improving the efficiency of your processes towards</b> driving your <b class="score">{{score}}%</b> NRR Growth</p>
        <p v-if="score > 33">
          By <b>better managing churn, improving customer experience, and demonstrating recurring value realization</b> with SmartKarrot, you can increase <b>NRR Growth by <b class="score">{{score}}%</b></b>.</p>
      </div>

    </div>
    <p><br /><br />Need a deeper dive? Schedule a demo to see the SmartKarrot platform in action today.
    <button v-on:click="showPopup">SCHEDULE A DEMO</button></p>

      <p>
        <small>
          *The data used to generate these calculations is based on real-world results reported by SmartKarrot mid-market customers operating in high-touch / hybrid-touch mode. (High-touch accounts are defined as those that need at least one touchpoint per fortnight.)
        </small>
      </p>
  </div>
</template>

<script>
export default {
  name: "Results",
  props: {
    form_data: Object,
    title: String,
    changeStep: Function,
    no_of_customers: Number,
    updateFormData: Function
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    showPopup: function() {
      /* eslint-disable */
      jQuery(".close_get_a_demo").remove();
      jQuery("#form_data_popup").remove();
      jQuery("#get-a-demo form").append("<input type='hidden' name='form_data' id='form_data_popup' value='"+JSON.stringify(this.form_data.field_values)+"' />");
      jQuery("#get-a-demo > .container").append(
        '<div class="close_get_a_demo"><i class="eicon-close"></i></div>'
      );
      jQuery(".get-a-demo-popup_overlay").remove();
      jQuery("#get-a-demo").append('<hr class="get-a-demo-popup_overlay" />');
      jQuery("#get-a-demo")
        .addClass("get-a-demo-popup")
        .fadeIn(800);

      jQuery(".close_get_a_demo,.get-a-demo-popup_overlay").click(function() {
        jQuery("#get-a-demo")
          .fadeOut()
          .removeClass("get-a-demo-popup");
      });
      
/* eslint-enable */
    }
  },
  computed: {
    score: function() {
      let score = 0;
      let constants = {
        tp: { roi: 20, budget: 40 },
        oe: { roi: 20, budget: 60 },
        ce: { roi: 30, budget: 0 },
        vr: { roi: 30, budget: 0 }
      };

      // let csm_account_ratio = 2.20512821;

      // let csm_account_ratio2 = 2.20512821;

      let team_productivity_roi =
        (
          ((this.form_data.field_values
            .to_what_extend_do_your_cms_meet_their +
            this.form_data.field_values.how_easy_is_it_fo_you_to_scale_teams +
            this.form_data.field_values.how_many_opeational_tools) *
            (constants.tp.roi / 3)) /
          100
        ).toFixed(1) * 1;

      let team_productivity_budget =
        (
          ((this.form_data.field_values
            .to_what_extend_do_your_cms_meet_their +
            this.form_data.field_values.how_easy_is_it_fo_you_to_scale_teams +
            this.form_data.field_values.how_many_opeational_tools) *
            (constants.tp.budget / 3)) /
          100
        ).toFixed(1) * 1;

      let opertaional_efficiency_roi =
        ((this.form_data.field_values
          .to_what_extend_are_your_current_cs_processes +
          this.form_data.field_values.to_what_extend_is_automation_employed +
          this.form_data.field_values.does_your_current_system_flag +
          this.form_data.field_values.are_your_processes_adaptable) *
          (constants.oe.roi / 4)) /
        100;
      // .toFixed(1) * 1
      let opertaional_efficiency_budget =
        ((this.form_data.field_values
          .to_what_extend_are_your_current_cs_processes +
          this.form_data.field_values.to_what_extend_is_automation_employed +
          this.form_data.field_values.does_your_current_system_flag +
          this.form_data.field_values.are_your_processes_adaptable) *
          (constants.oe.budget / 4)) /
        100;
      // .toFixed(1) * 1
      let customer_experience_roi =
        (
          ((this.form_data.field_values.are_your_cms_sufficiently +
            this.form_data.field_values
              .what_percentage_of_your_desired_audience +
            this.form_data.field_values.are_you_able_to_personalize +
            this.form_data.field_values.does_your_current_system_process) *
            (constants.ce.roi / 4)) /
          100
        ).toFixed(1) * 1;

      // let customer_experience_budget =
      //   (
      //     ((this.form_data.field_values.are_your_cms_sufficiently +
      //       this.form_data.field_values
      //         .what_percentage_of_your_desired_audience +
      //       this.form_data.field_values.are_you_able_to_personalize +
      //       this.form_data.field_values.does_your_current_system_process) *
      //       (constants.ce.budget / 4)) /
      //     100
      //   ).toFixed(1) * 1;

      let customer_experience_budget = 0;

      let value_realization_roi =
        ((this.form_data.field_values.are_your_csms_able_to_demonstrate +
          this.form_data.field_values.do_you_have_the_ability_to_drive) *
          (constants.vr.roi / 2)) /
        100;
      // .toFixed(1) * 1
      // let value_realization_budget =
      //   (
      //     ((this.form_data.field_values.are_your_csms_able_to_demonstrate +
      //       this.form_data.field_values.do_you_have_the_ability_to_drive) *
      //       (constants.vr.budget / 2)) /
      //     100
      //   ).toFixed(1) * 1;

      let value_realization_budget = 0;

      let roi =
        team_productivity_roi +
        opertaional_efficiency_roi +
        customer_experience_roi +
        value_realization_roi;

      let budget =
        team_productivity_budget +
        opertaional_efficiency_budget +
        customer_experience_budget +
        value_realization_budget;

      // let roi_calculated = csm_account_ratio * roi;
      // let budget_calculated = csm_account_ratio2 * budget;

      let roi_calculated = 19.5;
      let budget_calculated = 26.9;

      let asmt = 33;
      let mm = 100;
      let cgcnrrg = 28.9;
      let gr = this.form_data.field_values.anticipated_account_growth_in_next_period;

      if (this.form_data.selected_goal == 1) {
        score = (
          ((0 - budget_calculated / 100) / (1 - asmt / 100)) *
          (budget / 100 - 1) *
          100
        ).toFixed(0);
      } else if (this.form_data.selected_goal == 2) {
        score = (
          (gr - budget_calculated) /
          ((budget_calculated - 0) / (0 - roi_calculated * -1))
        ).toFixed(0);
      } else if (this.form_data.selected_goal == 3) {
        score = (
          (roi / 100 > asmt / 100
            ? (roi / 100 - asmt / 100) /
              ((mm / 100 - asmt / 100) / (cgcnrrg / 100 - 0))
            : cgcnrrg / 100) * 100
        ).toFixed(0);
      }

      return score;
    },
  }
};
</script>

<style scoped>
.results_wrapper {
  background: #eee;
  border: 1px solid rgb(200, 200, 200);
  border-radius: 3px;
  opacity: 1;
    padding: 10px 80px 20px 80px;
  margin-top: 50px;
  color:#000;
border-radius:20px;
}
h2 {
  font-size: 2.3em;
  padding-top: 30px;
}
.score_widget_number{
      font-size: 5.4em;
      margin: 30px 30px 50px 30px;
    color: #fff;
    filter: drop-shadow(2px 4px 6px rgba(0,0,0,0.2));
    background: #ef8e45;
    display: inline-flex;
    padding: 0.4em;
    border-radius: 100%;
    border: 4px dashed #ffffff;
    outline: 10px solid #ef8e45;
        min-width: 1.3em;
    min-height: 1.3em;
    justify-content: center;
    align-items: center;
}
.score_widget_number.swn_1{
    min-width: 1.3em;
    min-height: 1.3em;
}
.score_widget_number.swn_2{
min-width: 1.9em;
    min-height: 1.9em;
}
.score_widget_number.swn_3{

    min-width: 2em;
    min-height: 2em;
}
.score_widget_number.swn_4{

    min-width: 2.7em;
    min-height: 2.7em;
}
.result_description {
  font-size: 1em;
}
.result_description p {
    font-family: inherit;
    font-size: 1.2em;
}
.result_description b,
.result_description p b {
  color:#000;
  font-size: inherit;
    font-family: inherit;
}

.result_description b.score,
.result_description p b.score {
  color: #ef8e45;
  font-size: inherit;
    font-family: inherit;
}
small{

    font-size: 0.78em;
    line-height: 0.78em;
    color: #999;
}
button {
  text-align: center;
  letter-spacing: 0px;
  color: #ef8e45;
  opacity: 1;
  border: 1px solid #ef8e45;
  border-radius: 6px;
  opacity: 1;
  padding: 10px 20px;
  font-size: 1em;
  font-weight: 500;
  font-family: "Roboto Slab", serif;
  cursor: pointer;

  background: #ef8e45 0% 0% no-repeat padding-box;
  border-radius: 6px;
  opacity: 1;
  text-align: center;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
  display: block;
  margin-top: 20px;
}
@media all and (max-width: 600px) {
  h2 {
    font-size: 1.8em;
  }
  .results_wrapper {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
